// ------------------ STATE MAPPING ------------------
const getStateNameMap = () => ({
  "AL": "Alabama", "AK": "Alaska", "AZ": "Arizona", "AR": "Arkansas", "CA": "California",
  "CO": "Colorado", "CT": "Connecticut", "DE": "Delaware", "FL": "Florida", "GA": "Georgia",
  "HI": "Hawaii", "ID": "Idaho", "IL": "Illinois", "IN": "Indiana", "IA": "Iowa",
  "KS": "Kansas", "KY": "Kentucky", "LA": "Louisiana", "ME": "Maine", "MD": "Maryland",
  "MA": "Massachusetts", "MI": "Michigan", "MN": "Minnesota", "MS": "Mississippi", "MO": "Missouri",
  "MT": "Montana", "NE": "Nebraska", "NV": "Nevada", "NH": "New Hampshire", "NJ": "New Jersey",
  "NM": "New Mexico", "NY": "New York", "NC": "North Carolina", "ND": "North Dakota", "OH": "Ohio",
  "OK": "Oklahoma", "OR": "Oregon", "PA": "Pennsylvania", "RI": "Rhode Island", "SC": "South Carolina",
  "SD": "South Dakota", "TN": "Tennessee", "TX": "Texas", "UT": "Utah", "VT": "Vermont",
  "VA": "Virginia", "WA": "Washington", "WV": "West Virginia", "WI": "Wisconsin", "WY": "Wyoming"
});

// ------------------ LOCATION MATCHING ------------------
const getPreferredLocation = (userState) => {
  const locationMap = {
    "San Diego": {
      id: "gid://shopify/Location/96738705727",
      states: ["Arizona", "California", "Colorado", "Idaho", "Kansas", "Montana", "North Dakota", "Nebraska", "New Mexico", "Nevada", "Oklahoma", "Oregon", "South Dakota", "Texas", "Utah", "Washington", "Wyoming"]
    },
    "11 Enterprise Ave N": {
      id: "gid://shopify/Location/80654565695",
      states: ["New York", "New Jersey", "Pennsylvania", "Connecticut", "Rhode Island", "Massachusetts", "Vermont", "New Hampshire", "Maine", "Delaware", "Maryland", "Virginia", "West Virginia", "Ohio", "Indiana", "Illinois", "Michigan", "Wisconsin", "Minnesota", "Iowa", "Missouri", "Arkansas", "Louisiana", "Kentucky", "Tennessee", "North Carolina", "South Carolina", "Georgia", "Florida", "Alabama", "Mississippi"]
    }
  };

  for (const [locationName, { states }] of Object.entries(locationMap)) {
    if (states.includes(userState)) {
      return { name: locationName, id: locationMap[locationName].id };
    }
  }
  return null;
};

// ------------------ SHOW MODAL ------------------
const showStateModal = (detectedState = '') => {
  const existingModal = document.getElementById('stateModal');
  if (existingModal) existingModal.remove();

  const stateOptions = Object.entries(getStateNameMap())
    .map(([abbr, name]) => `<option value="${name}" ${name === detectedState ? 'selected' : ''}>${name}</option>`)
    .join('');

  const modalHTML = `
    <div id="stateModal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9999;">
      <div style="background: white; padding: 2rem; border-radius: 12px; max-width: 400px; width: 100%; text-align: center;">
        <p style="margin-bottom: 1rem;">
          <img src="https://img.icons8.com/ios-filled/50/000000/delivery.png" alt="Delivery Icon" style="width: 40px; height: 40px; margin-bottom: 1rem; display:block; margin:auto;" />
          <strong>To deliver your order in the best condition, we ship from the closest location.</strong><br>
          We detected your delivery state as <strong id="statePreview">${detectedState || 'Not available'}</strong> — is that correct?
        </p>
        <select id="userStateInput" style="padding: 0.5rem; width: 100%; margin-bottom: 1rem;">
          ${stateOptions}
        </select>
        <button onclick="saveState()" style="padding: 0.5rem 1rem; background: #333; color: white; border: none; border-radius: 6px;">
          Confirm
        </button>
      </div>
    </div>`;
  document.body.insertAdjacentHTML('beforeend', modalHTML);
};

// ------------------ SAVE STATE ------------------
const saveState = () => {
  const stateInput = document.getElementById('userStateInput');
  const state = stateInput.value;

  if (!state) {
    console.warn('State is empty. Please select a state.');
    return;
  }

  localStorage.setItem('userState', state);
  document.getElementById('stateModal').remove();
  document.dispatchEvent(new CustomEvent('stateUpdated', { detail: state }));
  location.reload();
};

// ------------------ CHECK INVENTORY ------------------
console.log("Location check script initialized.");

// Function to dynamically get product IDs from the page and filter by "FROZENGOOD"
const getFrozensFromPage = () => {
  console.log("Getting product IDs from the page...");

  const productElements = document.querySelectorAll('[data-product-id][data-tags]');
  const frozenProducts = [];

  productElements.forEach(element => {
    const productId = element.getAttribute('data-product-id');
    const productTags = element.getAttribute('data-tags').split(',');  
    if (productTags.includes('FROZENGOOD')) {
      frozenProducts.push(productId);
    }
  });
  console.log("Filtered frozen product IDs:", frozenProducts);
  return frozenProducts;
};

// Function to fetch inventory data for the filtered product IDs
const fetchInventoryData = async (productIds) => {
  console.log("Preparing to fetch inventory data from server...");
  console.log("Target endpoint: https://cuisinery.onrender.com/server/graphql");
  console.log("Request body:", JSON.stringify({ productIds }));

  if (productIds.length === 0) {
    console.log("No frozen product IDs found to fetch inventory for.");
    return;
  }

  try {
    const response = await fetch('https://cuisinery.onrender.com/server/graphql', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productIds }),
    });

    console.log("Response received from server.");
    console.log("HTTP Status:", response.status);

    if (!response.ok) {
      console.error("Response not OK:", response.statusText);
      return;
    }

    const data = await response.json();
    console.log("Parsed JSON response:", data);
    return data;
  } catch (error) {
    console.error("Fetch error occurred:", error);
  }
};

// Function to check the availability of frozen products
const checkFrozenInventory = (inventoryData, preferredLocationId) => {
  console.log("Checking frozen inventory...");

  if (!inventoryData || !Array.isArray(inventoryData.data?.nodes)) {
    console.log("No valid inventory data to check.");
    return;
  }

  inventoryData.data.nodes.forEach((product) => {
    console.log(`Processing frozen product: ${product.title} (ID: ${product.id})`);

    if (!product.variants?.edges) {
      console.warn(`No variants found for product ${product.title}`);
      return;
    }

    let allVariantsOutOfStock = true;

    product.variants.edges.forEach((variantEdge) => {
      const variant = variantEdge.node;
      const inventoryLevels = variant.inventoryItem?.inventoryLevels?.edges;

      if (!inventoryLevels || inventoryLevels.length === 0) {
        console.warn(`No inventory levels for variant ${variant.title}`);
        return;
      }

      let isInStockAtPreferredLocation = false;

      inventoryLevels.forEach((levelEdge) => {
        const level = levelEdge.node;

        if (level.location.id === preferredLocationId && level.quantities[0].quantity > 0) {
          isInStockAtPreferredLocation = true;
        }
      });

      if (isInStockAtPreferredLocation) {
        allVariantsOutOfStock = false;
      }
    });

    if (allVariantsOutOfStock) {
      // Match product element on the page
      const productIdShort = product.id.split("/").pop(); // Get just the ID part
      const productElement = document.querySelector(`[data-product-id="${productIdShort}"]`);

      if (productElement) {
        console.log(`🔴 Marking product ${product.title} as OUT OF STOCK`);
        
        // Add overlay label
        const outOfStockOverlay = document.createElement("div");
        outOfStockOverlay.textContent = "SOLD OUT";
        outOfStockOverlay.style.position = "absolute";
        outOfStockOverlay.style.top = "10px";
        outOfStockOverlay.style.left = "10px";
        outOfStockOverlay.style.backgroundColor = "rgba(255, 0, 0, 0.8)";
        outOfStockOverlay.style.color = "white";
        outOfStockOverlay.style.padding = "4px 8px";
        outOfStockOverlay.style.borderRadius = "6px";
        outOfStockOverlay.style.zIndex = "999";

        productElement.style.position = "relative";
        productElement.appendChild(outOfStockOverlay);

        // Optionally disable Add to Cart
        const addToCartBtn = productElement.querySelector('button[type="submit"], .add-to-cart, [name="add"]');
        if (addToCartBtn) {
  addToCartBtn.disabled = true;
  addToCartBtn.textContent = "SOLD OUT";
          addToCartBtn.classList.add("out-of-stock-button");
  addToCartBtn.style.backgroundColor = "#ccc";
  addToCartBtn.style.cursor = "not-allowed";
}
      }
    }
  });
};

// Main function to execute the process
const processFrozenInventoryCheck = async () => {
  console.log("Starting frozen inventory check...");

  const frozenProductIds = getFrozensFromPage();
  if (frozenProductIds.length === 0) {
    console.log("No frozen products found on the page, exiting.");
    return;
  }

  const userState = localStorage.getItem('userState');
  if (!userState) {
    console.warn("No user state found, showing state modal.");
    showStateModal('');  // Show the modal when the state is not set
    return;
  }

  const preferredLocation = getPreferredLocation(userState);
  if (!preferredLocation) {
    console.warn("Could not determine preferred location for state:", userState);
    return;
  }

  console.log("User state:", userState);
  console.log("Preferred shipping location:", preferredLocation);

  const inventoryData = await fetchInventoryData(frozenProductIds);
  if (!inventoryData) {
    console.log("No inventory data received, exiting.");
    return;
  }

  checkFrozenInventory(inventoryData, preferredLocation.id);
};

// Execute the frozen inventory check
processFrozenInventoryCheck();

// ------------------ GEOLOCATION ------------------
const getStateFromGeo = () => {
  if (!navigator.geolocation) {
    console.warn('Geolocation not supported.');
    showStateModal('');
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude } = position.coords;
      const geocodeURL = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyAfUhdNWvql_IT9a8hVLthuQ-CjE9XUqs0`;

      console.log('🛰️ Fetching geocode for:', latitude, longitude);
      console.log('🌍 Google Geocode URL:', geocodeURL);

      fetch(geocodeURL)
        .then(response => response.json())
        .then(data => {
          console.log('📦 Google Geocode API Response:', data);
          let fullStateName = '';

          if (data && data.results && data.results.length > 0) {
            for (const result of data.results) {
              const component = result.address_components.find(c => c.types.includes('administrative_area_level_1'));
              if (component) {
                const shortCode = component.short_name;
                fullStateName = getStateNameMap()[shortCode] || '';
                break;
              }
            }
          }

          console.log('🗺️ Extracted State:', fullStateName);
          showStateModal(fullStateName || 'Unknown');
        })
        .catch((error) => {
          console.error('🚨 Geocoding error:', error);
          showStateModal('');
        });
    },
    (err) => {
      console.warn('📵 Geolocation permission denied or failed:', err);
      showStateModal('');
    },
    { enableHighAccuracy: true }
  );
};

// ------------------ STICKY BAR STATE LABEL ------------------
const updateCurrentStateLabel = () => {
  const state = localStorage.getItem('userState') || 'Not selected';
  const label = document.getElementById('currentStateLabel');
  if (label) label.textContent = state;
};

document.addEventListener('DOMContentLoaded', updateCurrentStateLabel);
document.addEventListener('stateUpdated', updateCurrentStateLabel);
